module.exports = __webpack_public_path__ + "img/ref_cube.5fddf45f.png";